// tslint:disable
import { call, SearchResponse, SearchBody } from 'services/api-service'

/**
 * Instant answers search.
 *
 * @method
 * @name ApiService#instantAnswerSearch
 * @param {SearchBody} body -
 */
function instantAnswerSearch(body: SearchBody): Promise<SearchResponse> {
  return call<SearchResponse>('POST', '/{siteKey}/answer/search', {}, [], [], [], body)
}

export default { instantAnswerSearch }
